/// <amd-module name="Artifacts/Root/components/ComponentStateSwitch" />
import { ComponentState } from "Artifacts/Root/Constants";
import { isError, isLoading, isReady } from "Artifacts/Root/helpers/ComponentStateHelpers";
import * as React from "react";

interface IComponentStateSwitchProps {
  state: ComponentState;
  loading: React.ReactNode;
  ready: React.ReactNode;
  error: React.ReactNode;
}

/**
 * ComponentStateSwitch provides conditional component rendering depending on PageState value.
 * Use case for this component is rendering loading and error states.
 */
const ComponentStateSwitch: React.FC<IComponentStateSwitchProps> = ({
  state,
  loading,
  ready,
  error,
}) => (
  <>
    {isLoading(state) && loading}
    {isError(state) && error}
    {isReady(state) && ready}
  </>
);

export { ComponentStateSwitch };
